var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { FocusOutlineStyleTypeEnum } from '@inter-ikea-kompis/component-focus-outline';
import { FocusOutline } from '@inter-ikea-kompis/component-focus-outline';
import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';
import HyperlinkColorEnum from '../../enums/HyperlinkColorEnum.js';
import HyperlinkTargetEnum from '../../enums/HyperlinkTargetEnum.js';
import HyperlinkStyle from './HyperlinkStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Link class.
 *
 * @event linkClick Emits when clicking the hyperlink
 */
export default class Hyperlink extends KompisElement {
    constructor() {
        super(...arguments);
        // The same as href for a <a>-tag. If not set, element will act as a button.
        this.href = null;
        // The same as target for a <a>-tag
        this.target = HyperlinkTargetEnum.self;
        // True if there should be a underline when it's not in the hovered state
        this.underline = false;
        // Link color
        this.color = HyperlinkColorEnum.grey;
        // Text
        this.text = '';
        // Icon
        this.icon = null;
        // Aria-label for hyperlink. Note that this will override the content in text for screen readers.
        this.ariaLabel = '';
    }
    /**
     * Renders the component.
     *
     * @returns Returns a list to avoid line breaks.
     */
    render() {
        return [
            html `<style>
				${HyperlinkStyle.getStyle({
                underline: this.underline,
                theme: this.theme,
                color: this.color,
                hasIcon: Boolean(this.icon)
            })}
			</style>`,
            html `${this.getIcon()}`,
            html `${this.getLink()}`
        ];
    }
    connectedCallback() {
        this.customElements.define('kompis-focus-outline', FocusOutline);
        this.customElements.define('kompis-icon', Icon);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * Get link.
     */
    getLink() {
        return html `<kompis-focus-outline
			.theme="${this.theme}"
			.type="${FocusOutlineStyleTypeEnum.inline}"
			.invertedColors="${this.color === HyperlinkColorEnum.white || false}"
		>
			<a
				aria-label="${this.ariaLabel}"
				@click="${this.onLinkClick.bind(this)}"
				@keydown="${this.onKeyDown.bind(this)}"
				target="${this.href === null ? HyperlinkTargetEnum.self : this.target}"
				href="${this.href === null ? 'javascript:void(0)' : this.href}"
				role="${this.href === null ? 'button' : 'link'}"
				>${this.text}</a
			></kompis-focus-outline
		>`;
    }
    /**
     * Get icon.
     */
    getIcon() {
        if (!this.icon) {
            return null;
        }
        return html `<kompis-icon .theme="${this.theme}" .icon="${this.icon}"></kompis-icon>
			<div class="divider"></div>`;
    }
    /**
     * Click event.
     *
     * @param event Event.
     */
    onLinkClick(event) {
        event.stopPropagation();
        this.dispatchEvent(new CustomEvent('linkClick', { bubbles: true }));
    }
    /**
     * Event handler.
     *
     * @param event Event.
     */
    onKeyDown(event) {
        if (event.key === ' ') {
            // Prevent scrolling.
            event.preventDefault();
        }
        if (event.key === ' ') {
            this.shadowRoot?.querySelector('a')?.click();
        }
    }
}
__decorate([
    property({ type: String })
], Hyperlink.prototype, "href", void 0);
__decorate([
    property({ type: String })
], Hyperlink.prototype, "target", void 0);
__decorate([
    property({ type: Boolean })
], Hyperlink.prototype, "underline", void 0);
__decorate([
    property({ type: String })
], Hyperlink.prototype, "color", void 0);
__decorate([
    property({ type: String })
], Hyperlink.prototype, "text", void 0);
__decorate([
    property({ type: Object, required: true })
], Hyperlink.prototype, "theme", void 0);
__decorate([
    property({ type: String })
], Hyperlink.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], Hyperlink.prototype, "ariaLabel", void 0);
//# sourceMappingURL=Hyperlink.js.map